document.addEventListener("DOMContentLoaded", function () {

    document.addEventListener('change', function(e) {
        if (e.target.id === 'empty-cylinder-select') {
            const homeCylindersContainer = document.getElementById('home-cylinders-container');
            if (e.target.value === '1') {
                homeCylindersContainer.style.display = 'block';
            } else {
                homeCylindersContainer.style.display = 'none';
            }
        }
    });
        
    function updateMax() {
        const quantityInput = document.querySelector('[name="quantity"]');
        const homeEmptyInput = document.getElementById('home-empty-cylinders');
        if (homeEmptyInput && quantityInput) {
            homeEmptyInput.max = quantityInput.value || 1;
            if(homeEmptyInput.max < homeEmptyInput.value) {
                homeEmptyInput.value = homeEmptyInput.max;
            }
        }
    };

    window.updateMax = updateMax;

    if (document.querySelector('[name="quantity"]') != null && document.getElementById('home-empty-cylinders') != null) {
        updateMax();
    }


    document.addEventListener('change', function(e) {
        if (e.target && e.target.name === 'home_empty_cylinders') {
            const max = parseInt(e.target.max, 10) || 0;
            if (parseInt(e.target.value, 10) > max) {
                e.target.value = max;
            }
        }
    });
    document.addEventListener('keyup', function(e) {
        if (e.target && e.target.name === 'home_empty_cylinders') {
            const max = parseInt(e.target.max, 10) || 0;
            if (parseInt(e.target.value, 10) > max) {
                e.target.value = max;
            }
        }
    });

});

class SlotPickerEnhancer {
  constructor() {
    this.enhancedWidgets = new WeakSet();
    this.init();
  }
  
  init() {
    this.observeWidgets();
    this.watchForNewWidgets();
  }
  
  watchForNewWidgets() {
    const observer = new MutationObserver((mutations) => {
      const hasNewWidget = mutations.some(mutation => 
        mutation.type === 'childList' && 
        Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (
            node.tagName === 'PICKEASY-APP-WIDGET' || 
            node.querySelector?.('pickeasy-app-widget')
          )
        )
      );
      
      if (hasNewWidget) {
        setTimeout(() => this.observeWidgets(), 100);
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  observeWidgets() {
    document.querySelectorAll('pickeasy-app-widget').forEach(widget => {
      this.enhanceWidget(widget);
    });
  }
  
  enhanceWidget(widget) {
    if (this.enhancedWidgets.has(widget)) return;
    
    this.enhancedWidgets.add(widget);
    
    // Try multiple times to handle async rendering
    [0, 100, 300, 500].forEach(delay => {
      setTimeout(() => this.setupValidation(widget), delay);
    });
  }
  
  setupValidation(widget) {
    // Skip if already setup
    if (widget._validationSetup) return;
    
    const root = widget.shadowRoot || widget;
    const timeInput = root.querySelector('#neo-input-time');
    const dateInput = root.querySelector('#neo-input-date');
    const checkoutButton = widget.closest('sidebar-drawer')?.querySelector('#CheckOut') ||  document.querySelector('#CheckOut');

    if (!timeInput || !dateInput || !checkoutButton) return;
    
    widget._validationSetup = true;

    // Track last values to detect changes
    let lastValues = { time: '', date: '' };

    const getCurrentValues = () => ({
      time: (root.querySelector('#neo-input-time')?.value || '').trim(),
      date: (root.querySelector('#neo-input-date')?.value || '').trim()
    });

    const validateAndUpdate = () => {
      const current = getCurrentValues();
      
      // Skip if no change
      if (current.time === lastValues.time && current.date === lastValues.date) {
        return;
      }
      
      lastValues = current;
      if(!(current.time && current.date)){
        const picker = document.querySelector('pickeasy-slot-picker');
        checkoutButton.setAttribute('no-click', 'true');
        checkoutButton.addEventListener('click', (e) => {
          if(checkoutButton.getAttribute('no-click')) {
            e.preventDefault();
            e.stopPropagation();
           if (picker) {
             const error = document.getElementById('order-slots-error');
             error  ? error.textContent = 'Select an order slot to proceed' : picker.insertAdjacentHTML('afterend', '<p id="order-slots-error" class="order-slots-error">Select an order slot to proceed</p>');
           }
           return false;
          }
        });
      } else {
        checkoutButton.removeAttribute('no-click');
      }
      // checkoutButton.disabled = !(current.time && current.date);
    };

    // Debounced validation
    const debouncedValidate = () => {
      clearTimeout(widget._validationTimeout);
      widget._validationTimeout = setTimeout(validateAndUpdate, 100);
    };

    // Watch for DOM changes
    const observer = new MutationObserver(debouncedValidate);
    observer.observe(root, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    // Listen for user interactions
    ['change', 'blur'].forEach(event => {
      timeInput.addEventListener(event, debouncedValidate);
      dateInput.addEventListener(event, debouncedValidate);
    });

    // Store for cleanup
    widget._validationObserver = observer;

    // Initial validation
    validateAndUpdate();
  }
  
  destroy() {
    document.querySelectorAll('pickeasy-app-widget').forEach(widget => {
      widget._validationObserver?.disconnect();
      clearTimeout(widget._validationTimeout);
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
window.slotPickerEnhancer = new SlotPickerEnhancer();
}); 